<template>
    <!-- Modal de Item da Tabela -->
    <div
        class="modal fade"
        id="tabelaAtualizarPrecosModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-total modal-xl modal-dialog-scrollable" role="document" v-if="tipo">
            <div class="modal-content modal-content-total">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <span>
                            Atualização de Preços
                        </span>
                    </h5>
                    <button
                        type="button"
                        class="close"
                        @click="fechar_modal('tabelaAtualizarPrecosModal')"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <!-- Filtros -->
                    <div class="card dashcard mb-4">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        icon="far fa-credit-card"
                                        type="select"
                                        optionsMode="aql"
                                        optionsData="id_operadora"
                                        optionsDisplay="st_operadora"
                                        service="operadoras.index"
                                        placeholder="Selecionar operadora..."
                                        v-model="filtros.id_operadora"
                                        @input="load()"
                                    >
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        icon="far fa-credit-card"
                                        type="select"
                                        optionsMode="aql"
                                        optionsData="id_tabela_versao"
                                        :optionsParm="{ atualizacao_preco: true }"
                                        service="tabela_versaos.index"
                                        placeholder="Selecionar tabela versão..."
                                        v-model="filtros.id_tabela_versao"
                                        @input="load()"
                                    >
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        type="money"
                                        :precision="4"
                                        placeholder="Índice de atualização"
                                        v-model="filtros.indice"
                                    >
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="number"
                                        :precision="2"
                                        placeholder="Percentual de alerta"
                                        v-model="filtros.percentual"
                                        @input="filtros.percentual = parseFloat(filtros.percentual)"
                                    >
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend" title="Percentual de alerta">
                                            <div class="input-group-text">
                                                <i class="fa-solid fa-triangle-exclamation"></i>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa-solid fa-percent"></i>
                                            </div>
                                        </div>
                                    </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                    <button
                                        type="button"
                                        class="btn btn-primary mr-2"
                                        @click="load()"
                                    >
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <az-empty-state v-if="!dados" />

                    <template v-if="dados">

                        <div v-if="!lista || !lista.length">
                            <az-empty-state
                                :msg="'Nenhum item configurado para atualização. '"
                                icon="fas fa-search" />
                        </div>

                        <div v-else>

                            <table class="table table-sm bg-white table-hover cabecalho-fixo">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descrição</th>
                                        <th>Tabela</th>
                                        <th class="text-right">Valor Atual</th>
                                        <th class="text-right">Índice</th>
                                        <th class="text-right">Valor {{tipo == 'brasindice' ? 'Brasíndice' : 'Simpro'}}</th>
                                        <th>Fórmula</th>
                                        <th class="text-right">Valor Atualizado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista" :key="iix" :class="item.erro ? 'text-danger' : ''">
                                        <td>
                                            <span 
                                                v-if="item.erro"
                                                :title="'Não será atualizado #' + item.id_propria">
                                                <i class="fa fa-exclamation-triangle text-danger mr-2" aria-hidden="true"></i>
                                            </span>
                                            <span 
                                                v-else
                                                :title="'#' + item.id_propria">
                                                <i class="fa fa-check text-success mr-2" aria-hidden="true"></i>
                                            </span>
                                            {{ item.codigo }}
                                        </td>
                                        <td>{{ item.descricao }}</td>
                                        <td>{{ item.nome_tabela }}</td>
                                        <td class="text-right" :class="item.erro ? 'text-danger' : 'text-primary'">{{ $util.formatMoeda(item.valor_atual) }}</td>
                                        <td class="text-right text-warning">{{ $util.formatMoeda(item.indice, 6, 4) }}</td>
                                        <td class="text-right text-info">{{ $util.formatMoeda(item.valor_tabela) }}</td>
                                        <td class="text-muted">
                                            <small>

                                                <span 
                                                    v-if="item.info_valor != null"
                                                    data-toggle="tooltip" data-placement="top" data-html="true" 
                                                    title="Item não possui preço PMC">
                                                    <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                                </span>

                                                <template 
                                                    v-if="item.info_valor != null"
                                                    >
                                                    <span>icms: {{ item.info_valor.icms }}</span>
                                                    <span v-if="item.info_valor.valor_tabela"> , fator: {{ item.info_valor.valor_tabela }}</span>
                                                    <span v-if="item.info_valor.valor_pfb"> , pfb: {{ item.info_valor.valor_pfb }}</span>
                                                    <br />
                                                </template>

                                                <template v-if="item.conversao_unidade">
                                                    ({{ $util.formatMoeda(item.valor_tabela, 6, 2) }} {{ item.conversao_unidade =='M' ? '*' : '/'}} {{ $util.formatMoeda(item.fator_conversao, 6, 2) }})
                                                    * {{ $util.formatMoeda(item.indice, 6, 4) }}
                                                </template>
                                                <template v-else>
                                                    {{ $util.formatMoeda(item.valor_tabela, 6, 2) }} * {{ $util.formatMoeda(item.indice, 6, 4) }}
                                                </template>
                                            </small>
                                        </td>
                                        <td class="text-right" :class="item.erro ? 'text-danger' : 'text-success'">
                                            <span 
                                                v-if="item.percentual_icon"
                                                data-toggle="tooltip" data-placement="top" data-html="true" 
                                                :title="item.mensagem_percentual">
                                                <i :class="item.percentual_icon" style="color: red;"></i>
                                            </span>
                                            {{ item.erro ? '' : $util.formatMoeda(item.valor_atualizado) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </template>
                </div>

                <div class="modal-footer d-flex justify-content-end">
                    <div class="mr-4">
                        <input 
                            class="mr-1" 
                            type="checkbox" 
                            v-model="filtrar_valores_alterados" 
                        />
                        Filtrar valores fora do percentual.
                    </div>
                    <button
                        type="button"
                        class="btn btn-danger mr-2"
                        data-dismiss="modal"
                    >
                        Cancelar
                    </button>
                    <az-submit @click="confirmar_atualizacao()" :disabled="lista.length == 0">Confirmar</az-submit>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
//import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () {
        return {
            dados: null,
            tipo: null,
            codigo_item: null,
            filtrar_valores_alterados: false,
            filtros: {
                id_operadora: "",
                id_tabela_versao: "",
                indice: null,
                percentual: 100
            }
        };
    },

    components: {
        AzEmptyState,
        AzInput,
        AzSubmit,
    },

    computed: {
        lista: function () {
            if (!this.dados) return [];

            //Calcula o percentual de alteração
            let listaFiltrada = this.dados.map(item => {
                const valorAtual = item.valor_atual ? parseFloat(item.valor_atual.toFixed(2)) : 0; // Garante que seja um número
                const valorAtualizado = item.valor_atualizado ? parseFloat(item.valor_atualizado.toFixed(2)) : 0; // Garante que seja um número
                const percentualFiltro = parseFloat(this.filtros.percentual); // Garante que seja um número
                let percentualAlteracao = 0;

                // Calcula o percentual de alteração
                if (valorAtual != valorAtualizado && valorAtualizado != 0) {
                    percentualAlteracao = parseFloat(((valorAtualizado - valorAtual) / valorAtual * 100).toFixed(4));
                } else {
                    percentualAlteracao = 0;
                }

                item.percentual_alteracao = percentualAlteracao;


                // Define o ícone com base no percentual de alteração e no filtro
                if (Math.abs(item.percentual_alteracao) > percentualFiltro && !isNaN(percentualFiltro)) {
                    
                    item.mensagem_percentual = `Alteracao de ${item.percentual_alteracao}%`;

                    if (item.percentual_alteracao > 0 || item.percentual_alteracao < 0) {
                        item.percentual_icon = 'fa-solid fa-triangle-exclamation'; // Seta para cima
                    } else {
                        item.percentual_icon = null; // Sem alteração significativa
                    }
                } else {
                    item.percentual_icon = null; // Sem alteração significativa
                }

                return item;
            });

            //Realiza o filtro com base o            
            if (this.filtrar_valores_alterados) {
                listaFiltrada = listaFiltrada.filter(item => item.percentual_icon); // Caso o filtro não seja válido, mantém apenas os valores alterados
                
            }

            return listaFiltrada;
        }
    },

    methods: {

        show(tipo, item = null) {
            this.tipo = tipo;
            this.codigo_item = item;
            this.filtros.id_operadora = null;
            this.filtros.id_tabela_versao = null;

            $('#tabelaAtualizarPrecosModal').modal('show');

            this.load();
        },

        fechar_modal(modal) {
            $('#' + modal).modal('hide');
        },

        load() {
            this.$util.load(this, {
                service: "tabela_propria",
                func: "atualizar_precos",
                parms: {
                    tipo: this.tipo,
                    indice: this.filtros.indice,
                    id_operadora: this.filtros.id_operadora ? this.filtros.id_operadora : null,
                    id_tabela_versao: this.filtros.id_tabela_versao ? this.filtros.id_tabela_versao : null,
                    codigo_item: this.codigo_item
                },
                loadTo: res => {
                    this.dados = res;
                }
            });
        },

        confirmar_atualizacao() {

            if(!confirm('Deseja realmente atualizar os preços?')) {
                return;
            }

            this.$util.atualizar(this, {
                service: "tabela_propria",
                func: "atualizar_precos_confirma",
                dados: {
                    lista: this.lista
                },
                modal: "tabelaAtualizarPrecosModal",
            });

        }

    }
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
